export default __webpack_public_path__ + "static/media/jackpot-mobile-ms.1f56bb6e.webp";